import {
  WorkflowActionType,
  WorkflowAlert,
  WorkflowBaseDateTimeRef,
  WorkflowDetailSource,
} from './models/workflow.model';

export interface WorkflowStepFormStartOn {
  startOnType: StartOnEventType;
  startOnValue: string;
  startOnCustomValue?: string;
}

export interface WorkflowWaitActionParams {
  waitAmount?: string;
  waitAmountUnit?: WaitAmountUnit;
  waitTimePeriod?: WaitActionTimePeriod;
  waitBaseDateTimeRef?: WorkflowBaseDateTimeRef;
}

export interface WorkflowPublishEventActionParams {
  name: string;
  detailSource: WorkflowDetailSource;
  detailTemplate?: string;
}

export interface WorkflowStepFormData {
  name: string;
  description: string;
  startOn: WorkflowStepFormStartOn[];
  action?: WorkflowActionType;
  wait?: WorkflowWaitActionParams;
  publishAlert?: WorkflowAlert;
  taskHuman?: WorkflowAlert;
  publishEvent?: WorkflowPublishEventActionParams;
  isStart?: boolean;
  tempId?: string;
}

export type WorkflowStepFormActions = Pick<
  WorkflowStepFormData,
  'action' | 'wait' | 'publishAlert' | 'taskHuman' | 'publishEvent'
>;

export interface StartOnEventValue {
  key: string;
  value: string;
  isDisabled?: boolean;
}

export interface StartOnStepValue {
  stepId: string;
  status: StepResult;
}

export enum WaitActionTimePeriod {
  Before = 'before',
  After = 'after',
}

export enum StartOnEventType {
  Event = 'Event',
  Step = 'Step',
}

export enum StepResult {
  Success = 'Success',
  Failure = 'Failure',
  Canceled = 'Canceled',
}

export enum WaitAmountUnit {
  Days = 'Days',
  Hours = 'Hours',
  Minutes = 'Minutes',
}
